import React from 'react'

import { InputGroup, Checkbox, DropdownGroup, Flex } from '@clear/design-system'
import { Row } from '@components/layout/Form'
import { CountryOption } from '@api/getCountries'
import {
  BiographicSearchKeys,
  BiographicSearchLabels,
} from '@validators/schema/shared/biographicSearchSchema'
import { handleDataChange } from '@utils/handleDateChange'
import useSuffixOptions from '@hooks/useSuffixOptions'

function BiographicsStatusSearchView({
  register,
  noMiddleName,
  countries,
  firstNameErrorMessage,
  middleNameErrorMessage,
  lastNameErrorMessage,
  dobErrorMessage,
  countryOfBirthErrorMessage,
  setValue,
  showSuffix,
}: {
  register: any
  control: any
  noMiddleName: boolean
  countries: CountryOption[]
  firstNameErrorMessage?: string
  middleNameErrorMessage?: string
  lastNameErrorMessage?: string
  dobErrorMessage?: string
  countryOfBirthErrorMessage?: string
  setValue: any
  showSuffix?: boolean
}) {
  const [suffixes, isSuffixesLoading] = useSuffixOptions()
  return (
    <Flex flexDirection="column">
      <Row alignItems={[null, 'flex-start']}>
        <InputGroup
          {...register(BiographicSearchKeys.FIRST_NAME)}
          id={BiographicSearchKeys.FIRST_NAME}
          data-cy={BiographicSearchKeys.FIRST_NAME}
          name={BiographicSearchKeys.FIRST_NAME}
          label={BiographicSearchLabels.firstName}
          placeholder={BiographicSearchLabels.firstName}
          error={firstNameErrorMessage}
          containerProps={{
            width: [null, '50%'],
          }}
        />
        <InputGroup
          {...register(BiographicSearchKeys.MIDDLE_NAME)}
          id={BiographicSearchKeys.MIDDLE_NAME}
          data-cy={BiographicSearchKeys.MIDDLE_NAME}
          name={BiographicSearchKeys.MIDDLE_NAME}
          label={BiographicSearchLabels.middleName}
          placeholder={BiographicSearchLabels.middleName}
          disabled={noMiddleName}
          error={middleNameErrorMessage}
          containerProps={{
            width: [null, '25%'],
          }}
        />
        <Checkbox
          {...register(BiographicSearchKeys.NO_MIDDLE_NAME)}
          id={BiographicSearchKeys.NO_MIDDLE_NAME}
          data-cy={BiographicSearchKeys.NO_MIDDLE_NAME}
          name={BiographicSearchKeys.NO_MIDDLE_NAME}
          text={BiographicSearchLabels.noMiddleName}
          flexShrink={0}
          flexGrow={0}
          containerProps={{
            mt: [null, 6],
            width: [null, '25%'],
          }}
        />
      </Row>
      <Row>
        <InputGroup
          {...register(BiographicSearchKeys.LAST_NAME)}
          id={BiographicSearchKeys.LAST_NAME}
          data-cy={BiographicSearchKeys.LAST_NAME}
          name={BiographicSearchKeys.LAST_NAME}
          label={BiographicSearchLabels.lastName}
          placeholder={BiographicSearchLabels.lastName}
          error={lastNameErrorMessage}
        />
        <InputGroup
          data-cy="dateOfBirth"
          label="Date of Birth"
          placeholder="mm/dd/yyyy"
          {...register(BiographicSearchKeys.DOB)}
          onChange={(e) =>
            handleDataChange(e, setValue, BiographicSearchKeys.DOB)
          }
          error={dobErrorMessage}
        />
      </Row>
      <Row>
        <DropdownGroup
          {...register(BiographicSearchKeys.COUNTRY_OF_BIRTH)}
          id={BiographicSearchKeys.COUNTRY_OF_BIRTH}
          name={BiographicSearchKeys.COUNTRY_OF_BIRTH}
          data-cy={BiographicSearchKeys.COUNTRY_OF_BIRTH}
          label={BiographicSearchLabels.countryOfBirth}
          placeholder={BiographicSearchLabels.countryOfBirth}
          options={countries}
          error={countryOfBirthErrorMessage}
          containerProps={{
            width: [null, '50%'],
          }}
        />
        {showSuffix && (
          <DropdownGroup
            label="Suffix (Optional)"
            placeholder="Suffix (Optional)"
            data-cy={BiographicSearchKeys.SUFFIX}
            options={suffixes}
            disabled={isSuffixesLoading}
            {...register('suffix')}
            autoComplete="honorific-suffix"
            containerProps={{
              width: [null, '50%'],
            }}
          />
        )}
      </Row>
    </Flex>
  )
}

export default BiographicsStatusSearchView
